module.exports = __webpack_public_path__ + "img/bear.3e973d2.png";